<script lang="ts">
	import __ from '$lib/stores/TranslationStore';
	import bell from '$lib/assets/images/simulation/bell.webp';
	import CloseOutline from '$lib/assets/images/icons/x-close.svg?component';
	import Documents from '$lib/assets/images/icons/documents-outline.svg?component';
	import Cupcake from '$lib/assets/images/icons/cupcake.svg?component';
	import Money from '$lib/assets/images/icons/money-outline.svg?component';
	import Cash from '$lib/assets/images/icons/cash-outline.svg?component';
	import Home from '$lib/assets/images/icons/home.svg?component';
	import Search from '$lib/assets/images/icons/search-outline.svg?component';
	import { createEventDispatcher } from 'svelte';
	import { twMerge } from 'tailwind-merge';

	const dispatch = createEventDispatcher();

	let className: string = '';
	export { className as class };
</script>

<div
	class={twMerge(
		'm-10 flex h-fit w-[312px] flex-col gap-5 rounded-lg bg-white px-7 py-5',
		className
	)}
>
	<span class="h-3">
		<button on:click={() => dispatch('close')} class="float-right -mr-2">
			<CloseOutline class=" h-9 stroke-slate stroke-2" />
		</button>
	</span>
	<div class="flex gap-5">
		<figure class="shrink-0">
			<img class="w-[65px]" src={bell} alt="Reminder" />
		</figure>
		<h2 class="text-lg/4 font-semibold text-black">
			{@html $__('Antes de <br> começar, confira os requisitos para pedir o crédito!')}
		</h2>
	</div>
	<ul class="flex flex-col divide-y-1.8">
		<li class="flex gap-2 py-1">
			<span class="flex flex-col justify-center">
				<Documents />
			</span>
			<div class="text-sm">
				<h3 class="font-bold">{$__('Documento de identificação')}:</h3>
				<p>{$__('Cartão de cidadão ou título de residência')}</p>
			</div>
		</li>
		<li class="flex gap-2 py-1">
			<span class="flex flex-col justify-center">
				<Cupcake />
			</span>
			<div class="text-sm">
				<h3 class="font-bold">{$__('Idade')}:</h3>
				<p>{$__('Acima de 18 anos')}</p>
			</div>
		</li>
		<li class="flex gap-2 py-1">
			<span class="flex flex-col justify-center">
				<Money />
			</span>
			<div class="text-sm">
				<h3 class="font-bold">{$__('Rendimento mensal')}:</h3>
				<p>{$__('Superior a 820€ (tributado em Portugal)')}</p>
			</div>
		</li>
		<li class="flex gap-2 py-1">
			<span class="flex flex-col justify-center">
				<Cash />
			</span>
			<div class="text-sm">
				<h3 class="font-bold">{$__('Montante solicitado')}:</h3>
				<p>{$__('Mínimo de 5.000€')}</p>
			</div>
		</li>
		<li class="flex gap-2 py-1">
			<span class="flex flex-col justify-center">
				<Home class="" />
			</span>
			<div class="text-sm">
				<h3 class="font-bold">{$__('Residência fiscal')}:</h3>
				<p>{$__('Comprovada em Portugal')}</p>
			</div>
		</li>
		<li class="flex gap-2 py-1">
			<span class="flex flex-col justify-center">
				<Search />
			</span>
			<div class="text-sm">
				<h3 class="font-bold">{$__('Histórico de crédito')}:</h3>
				<p>{$__('Ter responsabilidades de crédito ativas')}</p>
			</div>
		</li>
	</ul>
</div>
